import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearSettings,
  fetchAllAdministrationRulesPageable,
  fetchFilterSettings,
  fetchTableActionsSettings,
  fetchTableSettings,
  updateFilterSettings,
  updateTableActionsSettings,
  updateTableSettings,
} from '../../actions/administration';
import { numberOfItemsPerPage } from '../../constants/globals.js';
import withTranslations from '../../utils/HighOrderComponent';
import AdministrationTable from '../Administration/AdministrationTable';

const AdministrationList = (props) => {
  const { t, gt } = props || {};
  const dispatch = useDispatch();

  const { loadingAdministrationRules, administrationRulesList, totalElements } =
    useSelector((state) => state.administrationReducer);

  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(numberOfItemsPerPage);

  useEffect(() => {
    dispatch(fetchAllAdministrationRulesPageable(activePage, pageSize));
  }, [activePage, pageSize, dispatch]);

  return (
    <AdministrationTable
      administrationRulesList={administrationRulesList}
      t={t}
      gt={gt}
      page={activePage}
      rowsPerPage={pageSize}
      totalElements={totalElements}
      setActivePage={setActivePage}
      setPageSize={setPageSize}
      loading={loadingAdministrationRules}
      clearSettings={clearSettings}
      fetchFilterSettings={fetchFilterSettings}
      fetchTableActionsSettings={fetchTableActionsSettings}
      fetchTableSettings={fetchTableSettings}
      updateFilterSettings={updateFilterSettings}
      updateTableSettings={updateTableSettings}
      updateTableActionsSettings={updateTableActionsSettings}
    />
  );
};

export default withTranslations(AdministrationList, 'AdministrationPage');
